import type React from 'react';
import { memo } from 'react';

import * as styles from './styles';

import { CheckIcon } from '../icons';

import Button from '@cobliteam/ui/components/Button';

export interface WizardButtonProps {
  startIcon?: React.ReactNode;
  text: string;
  checked: boolean;
  disabled: boolean;
  onClick: () => void;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const WizardButton: React.FC<WizardButtonProps> = (props: WizardButtonProps) => {
  const { startIcon, text, checked, disabled, onClick } = props;

  const checkIconClassName = checked ? styles.endIconColored : styles.endIcon;

  return (
    <>
      <Button variant='outlined' color='default' startIcon={startIcon} className={styles.wizardButtonContainer(disabled)} onClick={onClick}>
        {text}
        <CheckIcon className={checkIconClassName} />
      </Button>
    </>
  );
};

export default memo(WizardButton);
